import { useReveal } from "@/hooks/useReveal";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Download } from "lucide-react";

export default function FinalCTA() {
  const { ref, visible } = useReveal();
  const navigate = useNavigate();

  return (
    <section
      id="final-cta"
      ref={ref}
      data-testid="final-cta-section"
      className="relative py-24 md:py-36 border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="absolute inset-0 bg-radial-fade pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="h-px w-12 bg-white/15" />
          <span className="num-label">SECTION 11 / FINAL TRANSMISSION</span>
          <div className="h-px w-12 bg-white/15" />
        </div>

        <h2
          data-testid="final-cta-headline"
          className={`font-display font-bold tracking-tight text-axiom-text text-4xl sm:text-5xl lg:text-7xl leading-[1.02] reveal ${
            visible ? "in" : ""
          }`}
        >
          See the System <br />
          <span className="text-axiom-muted">Beneath the</span>{" "}
          <span className="text-axiom-accent">Symptom.</span>
        </h2>

        <p
          className={`mt-8 max-w-2xl mx-auto text-axiom-muted text-base sm:text-lg leading-relaxed reveal ${
            visible ? "in" : ""
          }`}
          style={{ transitionDelay: "120ms" }}
        >
          If your organization is seeing cost pressure, service instability,
          dwell, empty miles, forecasting noise, or visibility gaps, the issue
          may not be where the report says it is. Axiom-AI helps leaders trace the
          signal back to the operating decision that created it.
        </p>

        <div
          className={`mt-10 flex flex-col sm:flex-row gap-3 justify-center reveal ${
            visible ? "in" : ""
          }`}
          style={{ transitionDelay: "220ms" }}
        >
          <button
            data-testid="final-cta-primary"
            onClick={() => navigate("/contact")}
            className="btn-axiom"
          >
            Request a Strategic Review
            <ArrowRight size={16} />
          </button>
          <button
            data-testid="final-cta-secondary"
            onClick={() =>
              document
                .getElementById("lead-magnet")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="btn-axiom-outline"
          >
            Download the Diagnostic
            <Download size={14} />
          </button>
        </div>
      </div>
    </section>
  );
}
